export function convertSnakeCaseToReadableString(str: string) {
  if (!str) return str;
  return str
    .replaceAll("_", " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}
